export default __webpack_public_path__ + "static/media/PC-02.39c1a40b.jpg";